export default [
  // *===============================================---*
  // *--------- 业务相关页面路由 -------------------------------*
  // *===============================================---*
  //设备列表
  {
    path: '/diagnostic/device/list',
    name: 'diagnostic-device-list',
    component: () => import('@/views/diagnostic/device/List.vue'),
	meta: {
	  pageTitle: 'Device List',
	  breadcrumb: [
	    {
	      text: 'Device List',
		  active: true,
	    },
	  ],
	  resource: 'ACL',
	  action: 'read'
	},
  },
  //设备添加
  {
    path: '/diagnostic/device/add',
    name: 'diagnostic-device-add',
    component: () => import('@/views/diagnostic/device/Add.vue'),
	meta: {
	  pageTitle: 'Add Device',
	  breadcrumb: [
	    {
	      text: 'Device List',
		  to:'/diagnostic/device/list'
	    },
	    {
	      text: 'Add Device',
	      active: true,
	    },
	  ],
	},
  },
  //设备修改
  {
    path: '/diagnostic/device/:name',
    name: 'diagnostic-device-edit',
    component: () => import('@/views/diagnostic/device/Edit.vue'),
  	meta: {
  	  pageTitle: 'Edit Device',
  	  breadcrumb: [
  	    {
  	      text: 'Device List',
  		  to:'/diagnostic/device/list'
  	    },
  	    {
  	      text: 'Edit Device',
  	      active: true,
  	    },
  	  ],
  	},
  },
  //任务列表
  {
    path: '/diagnostic/task/list',
    name: 'diagnostic-task-list',
    component: () => import('@/views/diagnostic/task/List.vue'),
	meta: {
	  pageTitle: 'Task List',
	  breadcrumb: [
	    {
	      text: 'Task List',
		  active: true,
	    },
	  ],
	  resource: 'ACL',
	  action: 'read'
	},
  },
  //任务添加
  {
    path: '/diagnostic/task/add',
    name: 'diagnostic-task-add',
    component: () => import('@/views/diagnostic/task/Add.vue'),
	meta: {
	  pageTitle: 'Add Task',
	  breadcrumb: [
	    {
	      text: 'Task List',
		  to:'/diagnostic/task/list'
	    },
	    {
	      text: 'Add Task',
	      active: true,
	    },
	  ],
	  resource: 'ACL',
	  action: 'read'
	},
  },
  //任务查看
  {
    path: '/diagnostic/task/:name',
    name: 'diagnostic-task-view',
    component: () => import('@/views/diagnostic/task/View.vue'),
  	meta: {
  	  pageTitle: 'View Task',
  	  breadcrumb: [
  	    {
  	      text: 'Task List',
  	      to:'/diagnostic/task/list'
  	    },
  	    {
  	      text: 'View Task',
  	      active: true,
  	    },
  	  ],
	  resource: 'ACL',
	  action: 'read'
  	},
  },
  //诊断数据列表
  {
    path: '/diagnostic/data/list',
    name: 'diagnostic-data-list',
    component: () => import('@/views/diagnostic/data/List.vue'),
	meta: {
	  pageTitle: 'Data List',
	  breadcrumb: [
	    {
	      text: 'Data List',
		  active: true,
	    },
	  ],
	  resource: 'ACL',
	  action: 'read'
	},
  },
  //诊断数据查看
  {
    path: '/diagnostic/data/:name',
    name: 'diagnostic-data-view',
    component: () => import('@/views/diagnostic/data/View.vue'),
  	meta: {
  	  pageTitle: 'View Data',
  	  resource: 'ACL',
  	  action: 'read',
	  layout: 'full'
	},
  },
]
